import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: '16px 8px',
    border: 'none',
    background: 'transparent',
    borderBottom: `1px solid ${theme.palette.secondary.light}`,
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '56px 1fr 32px',
    alignItems: 'center',
  },
  iconContainer: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
  },
  doneContainer: {
    background: theme.palette.success.light,
  },
  warningContainer: {
    background: theme.palette.warning.light,
  },
  done: {
    width: 18,
    height: 'auto',
    color: theme.palette.success.main,
  },
  warning: {
    width: 18,
    height: 'auto',
  },
  detail: {
    textAlign: 'left',
  },
  detailName: {
    marginTop: 4,
  },
  buttonIcon: {
    color: theme.palette.primary.dark,
    width: '24px',
  },
  drawer: {
    '& .MuiDrawer-paper': {
      padding: '24px',
    },
  },
  choiceContainer: {
    paddingTop: 24,
  },
  choice: {
    width: '100%',
    marginBottom: 8,
  },
}))

export default useStyles
